<script setup>
import { defineProps } from 'vue'

const props = defineProps({
  text: {
    type: String,
    required: false,
    default: 'No data.'
  }
})
</script>

<template>
  <v-card-subtitle style="font-size: 13px">
    {{ text }}
  </v-card-subtitle>
</template>
